import React from "react";
import Slider from "react-slick";

const BannerThree = () => {
  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1500,
    dots: false,
    pauseOnHover: true,
    arrows: false,
    infinite: true,
  };

  return (
    <section className='bg-white px-0 py-0 banner-three-section'>
      <Slider {...settings} className='banner-three-slider'>
        <div>
          <img
            src='assets/images/thumbs/hero1.png'
            alt='Banner 1'
            className='w-100 h-100 banner-three-img'
          />
        </div>
        <div>
          <img
            src='assets/images/thumbs/hero2.png'
            alt='Banner 2'
            className='w-100 h-100 banner-three-img'
          />
        </div>
        <div>
          <img
            src='assets/images/thumbs/hero3.png'
            alt='Banner 3'
            className='w-100 h-100 banner-three-img'
          />
        </div>
      </Slider>
    </section>
  );
};

export default BannerThree;
